export default __webpack_public_path__ + "benjamin.0677eb4.png";